import { HEALTH, healthOf, isOverdue, openTasks } from "../lib/domain.js";

/* The portfolio in five figures. One object, hairline-divided, so the
   counts read as a single instrument rather than five cards. */
export function SummaryRail({ board }) {
  const counts = { healthy: 0, "at-risk": 0, critical: 0 };
  let open = 0;
  let overdue = 0;

  for (const pg of board) {
    counts[healthOf(pg)]++;
    open += openTasks(pg);
    overdue += pg.tasks.filter(isOverdue).length;
  }

  const cells = [
    ["healthy", "Healthy", counts.healthy],
    ["at-risk", "At risk", counts["at-risk"]],
    ["critical", "Critical", counts.critical],
  ];

  return (
    <section className="rail" aria-label="Portfolio summary">
      {cells.map(([key, label, n]) => (
        <div key={key} className={"cell tone " + HEALTH[key].tone}>
          <span className="n">{n}</span>
          <span className="label">
            <i className="dot" />
            {label}
          </span>
        </div>
      ))}
      <div className="cell">
        <span className="n">{open}</span>
        <span className="label">Open tasks</span>
      </div>
      <div className={"cell" + (overdue ? " tone tone-bad" : "")}>
        <span className="n">{overdue}</span>
        <span className="label">Past committed date</span>
      </div>
    </section>
  );
}
